import Axios from 'axios';

import { Entity }           from '$/entities/BaseEntity';
import { Organization }     from '$/entities/Organization';
import { PackageFeature }   from '$/entities/Package';
import { entity }           from '$/entities/runtimeEntities';
import type { TenantCheck } from '$/entities/tenantScreening/TenantCheck';

import { Application as ApplicationCommon } from '$/common/entities/tenantScreening/Application';
export * from '$/common/entities/tenantScreening/Application';

@Entity()
export class Application extends ApplicationCommon {

	/**
	 * Intended to be used by an Applicant to ensure that the Application is complete.
	 */
	async ensureApplication() {
		await Axios.post(Application.collectionUrl(`/${this.id}/ensure-application`));
		await this.reload();
	}

	/**
	 * Request the reports from Equifax/Certn/TenantAlert for each of the tenant checks in this application
	 */
	async requestReports() {
		await Axios.post(Application.collectionUrl(`/${this.id}/request-reports`));
		await this.reload();
	}

	async sendInvite() {
		await Axios.post(Application.collectionUrl(`/${this.id}/send-invite`));
	}

	async unarchive() {
		await Axios.post(Application.collectionUrl(`/${this.id}/unarchive`));
		await this.reload();
	}

	showReport() {
		window.open(Application.collectionUrl(`/${this.id}/report`));
	}

	static showSampleReport(org: Organization = entity.Organization.current, types?: typeof TenantCheck[], tenantAlertPro?: boolean) {
		if (!types) {
			if (org.isCanadian) {
				types = [ entity.EquifaxCreditReport, entity.BackgroundCheckOld, entity.TenantSearch ];
			}
			else if (org.hasFeature(PackageFeature.CreditChecksPro)) {
				types          = [ entity.TenantAlertCreditCheck ];
				tenantAlertPro = true;
			}
			else {
				types = [ entity.CertnCreditReport ];
			}
		}

		window.open(Application.collectionUrl('/sample-report', {
			types          : types.filter(t => t !== entity.PersonaIDVCheck).map(type => type.name).join(','),
			tenantAlertPro : tenantAlertPro ? 'true' : undefined,
		}));
	}

	static async getSampleEmail() {
		return (await Axios.get(Application.collectionUrl('/sample-email'))).data;
	}

}
